import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  Routes, RouterModule, Router, Event as RouterEvent, NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';

import { AppConfig } from '../app.config';
import { SelectivePreloadingStrategy } from './selective-preloading-strategy';
import { NgProgressModule } from '@ngx-progressbar/core';
import { NgProgressRouterModule } from '@ngx-progressbar/router';

import { AuthModule, AuthGuard } from '../_authentication/auth';
import { VertragModule } from '../_vertrag/vertrag.module';

const appRoutes: Routes = [
  { path: '', redirectTo: '/vertrag', pathMatch: 'full' },  
  { path: 'vertrag', loadChildren: 'app/_vertrag/vertrag.module#VertragModule', canActivate: [AuthGuard]  },
  { path: 'auth', loadChildren: 'app/_authentication/auth.module#AuthModule' },
  { path: '**', redirectTo: '/vertrag' }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(appRoutes, AppConfig.RoutingConfig),
    NgProgressModule.forRoot(),
    NgProgressRouterModule,
    AuthModule,
    VertragModule,
  ],
  exports: [
    RouterModule
  ],
  providers: [
    SelectivePreloadingStrategy
  ]
})
export class AppRoutingModule {
  constructor(private router: Router) {

  }
}


// WEBPACK FOOTER //
// ./src/app/routing/routing.ts